/* eslint-disable
    default-case,
    no-restricted-syntax,
    no-unreachable,
    prefer-const
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS201: Simplify complex destructure assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import reactUpdate, {Spec} from 'immutability-helper';
import isEqual from 'react-fast-compare';
import _ from 'underscore';

import {assert, debugAssert} from 'Asserts';
import {DataModificationsHeader} from 'audit/DataModifications';
import BenchlingConfig from 'BenchlingConfig';
import * as context from 'Context';
import {CidIdMap} from 'notebook/notes/NoteConstants';
import AutoSaver from 'notebook/store/auto-save/AutoSaver';
import {UPDATE_ALL_ITEM_PARTS} from 'notebook/store/auto-save/ItemPartSaveTracker';
// @ts-expect-error ts(7016)
import drafts from 'notebook/store/data-recovery/Drafts';
import ensureMutable from 'notebook/store/ensureMutable';
// @ts-expect-error ts(7016)
import HistoryManager from 'notebook/store/HistoryManager';
import * as VersioningConstants from 'notebook/store/VersioningConstants';
import {EvaluationMetrics} from 'notebook/tables/excess/EvaluationConstants';
import {MultidocTableOpMap} from 'notebook/tables/excess/ops/TableOpConstants';
import SpreadsheetEvalCache from 'notebook/tables/spreadsheets/SpreadsheetEvalCache';
import notifications from 'notifications';

/**
 * The VersionedItemSubstore is responsible for keeping track of the relationship between the identity of the
 * content shown to the user and the identity of that content contained on the backend.  The `Id` type here is
 * the type of the identity that is used on the backend while the `Cid` type is always a string.  The `Id`
 * type can vary but was historically a number as it was the database `id` column of the versioned piece of
 * content, e.g. the primary key of the EntryVersion row.  However, there are some places where the `Id` can
 * be a `string`.  These were usually pieces of NoteLinkedObjects where the `Id` is a UUID-like identifier
 * that identifies the content within the Entry Version itself.
 */
type Id = number | string;

interface Events {
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface EditorStateMetadata {
  latestVersionId: number;
  clientId: string;
  action: string | null;
}

export interface BaseItemEditorState<TRoot = unknown, TRootPart = unknown> {
  historyManager: typeof HistoryManager;
  autoSaver?: AutoSaver<TRoot, TRootPart> | null;
  cidIdMap: CidIdMap;
  isAutoSaving: boolean;
  isLatest: boolean;
  metadata: EditorStateMetadata;
  latestVersionId?: number;
  openVersion: number;
  openVersionId: number;
  savedVersion: number;
  saving: boolean;
  opening: boolean;
  dirty: boolean;
  saveSuccess: boolean;
  lockedFromExternalChange: boolean;
  actionMeta: {
    action: string;
    versionId: number;
  } | null;
  customSaveHandler?: ItemSaveHandler;
  getRelatedDocumentIds?: () => Array<string>;
  historyResetCount: number;
  collaboratorIds: Array<string>;
}

export type ItemData<TRoot, TItemKey extends string, TIdKey extends string> = {
  [key in TIdKey]: Id;
} & {
  [key in TItemKey]: TRoot;
};

export type ItemEditorState<
  TRoot,
  TRootPart,
  TItemKey extends string,
  TIdKey extends string,
> = BaseItemEditorState<TRoot, TRootPart> & ItemData<TRoot, TItemKey, TIdKey>;

interface ItemAction<TRoot, TRootPart, TItemKey extends string, TIdKey extends string> {
  actionType: string;
  items: Array<ItemEditorState<TRoot, TRootPart, TItemKey, TIdKey>>;
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface ItemVersionState<TVersion> {
  versions: Array<TVersion>;
  fetching: boolean;
  fetchSuccess: boolean;
  hasParent: boolean;
  parent: {
    name: string;
    id: string;
    versionId: number;
    modifiedAt: string;
  } | null;
  openVersionId?: number | false;
  openVersionApiId?: string;
  openVersionModifiedAt?: string;
  isLatest?: boolean;
  unsaved?: boolean;
  dirty?: boolean;
  savedVersion?: number;
}

interface UpdateOptions {
  /**
   * Indicates that the update being applied is versioned and will be
   * updated through the auto-save mechanism, in which case the versioned contents cannot be out-of-date
   * (dirty). On the other hand, `!bumpVersion` indicates the the update being applied to the item is either UI
   * state or a persisted field tht is not versioned and likely already applied via postServerUpdate and is
   * thus orthogonal to the state of the versioned contents. In the future, we may want to pull all such state
   * out of VersionedItemSubstore to avoid this confusing conflation.
   */
  bumpVersion?: boolean;
  /**
   * Indicates that the update being applied should trigger
   * table evaluation.
   */
  performTableEvaluation?: boolean;
  /**
   * Indicates that the update being applied should skip dismissing validation errors as stale.
   * Defaults to false.
   */
  skipValidationStalenessCheck?: boolean;

  /**
   * The indexes of the item parts that were updated. This is used to determine which ite parts
   * should be saved when the auto-saver is triggered.
   */
  updatedItemPartIndexes?: Array<number>;

  /**
   * Indicates that the update being applied should be saved incrementally rather than all at once.
   */
  canIncrementalSave?: boolean;

  /**
   * An object representing the table edit operations in the table space for one or more documents.
   */
  multidocTableOp?: MultidocTableOpMap;

  /**
   * Evaluation metrics tracking for quiescence measurement.
   */
  evalMetrics?: EvaluationMetrics;
}

export type ItemSaveHandler = (dataModsHeader?: DataModificationsHeader) => Promise<boolean>;

interface SubstoreOptions {
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface VersionBase {
  id: Id;
  apiIdentifier?: string;
  api_identifier?: string;
  modifiedAt?: string;
}

class VersionedItemSubstore<
  TClientRoot = unknown,
  TClientRootPart = unknown,
  TServerRoot = unknown,
  TServerVersion extends VersionBase = VersionBase,
  TItemKey extends string = string,
  TIdKey extends string = string,
> {
  private events: Events;
  private doSave: (() => void | JQueryPromise<boolean>) | ((id: string) => void) | null;
  private asyncItemLoad: boolean;
  private enableItemPartLevelSaving?: boolean;
  private idKey: TIdKey;
  private itemKey: TItemKey;
  private itemNameKey: string;
  private itemURLKey: string;
  private getItemParts: (item: TClientRoot) => Array<{itemPartId: string; itemPart: TClientRootPart}>;
  private getVersionCid: (item: TClientRoot) => string;
  private sanitizeItem: (item: TClientRoot, prevItem?: TClientRoot) => TClientRoot;
  // This is public because it is currently stubbed in tests.
  public postSanitizeItem: (
    id: Id,
    sanitizedItem: TClientRoot,
    prevItem: TClientRoot | null,
    options: UpdateOptions
  ) => TClientRoot;
  private postProcess: (
    item: ItemEditorState<TClientRoot, TClientRootPart, TItemKey, TIdKey>
  ) => ItemEditorState<TClientRoot, TClientRootPart, TItemKey, TIdKey>;
  private invertPostProcess: (item: TClientRoot) => TClientRoot;
  private pickRevertableFields: (item: TClientRoot) => TClientRoot;
  private prepareForStore: (item: TServerRoot, cidIdMap: Record<string, string>) => TClientRoot;
  public items: Record<Id, ItemEditorState<TClientRoot, TClientRootPart, TItemKey, TIdKey>> = {};
  private versions: Record<Id, ItemVersionState<TServerVersion>> = {};

  constructor({events, options}: {events: Events; options: SubstoreOptions}) {
    this.events = events;
    _.defaults(options, {
      // Wraps an item during load/update, can be used to insert default empty items
      sanitizeItem: null,

      // Performs any post processing on a versioned object to be returned in getEditorState
      // eslint-disable-next-line @typescript-eslint/unbound-method
      postProcess: _.identity,

      // Inverts operations done by postProcess to the object (NOT versioned object) to be stored in the store
      // eslint-disable-next-line @typescript-eslint/unbound-method
      invertPostProcess: _.identity,

      // Takes a server-side model and adds cids to the model.
      // Returns a hash of {cidIdMap, item}
      prepareForStore: null,

      // Picks fields from an item that can be reverted for undo/redo
      pickRevertableFields: null,

      // The key for the item from an action payload.
      // Also used to key the item inside the internal item hash.
      itemKey: null,

      // The key for the id of an item from an action payload
      idKey: 'id',

      // The key for the name of an item
      itemNameKey: 'name',

      // The key for the url of an item
      itemURLKey: 'editURL',

      getItemParts() {
        return [];
      },

      // Given an item, returns the cid corresponding to the currently loaded version
      getVersionCid: (item: {cid: string}) => item.cid,

      // True if there is an init, completed, and failed events for item load
      // Pass in a hash for item.load if this is the case.
      asyncItemLoad: false,

      // Function that calls the appropriate save action from AutoSaver. If null AutoSaver is disabled.
      doSave: null,

      // Boolean indicating if the item parts can be saved separately
      enableItemPartLevelSaving: false,
    });

    const {item, version, versions} = this.events;
    ({
      doSave: this.doSave,
      asyncItemLoad: this.asyncItemLoad,
      enableItemPartLevelSaving: this.enableItemPartLevelSaving,
    } = options);
    ({
      idKey: this.idKey,
      itemKey: this.itemKey,
      itemNameKey: this.itemNameKey,
      itemURLKey: this.itemURLKey,
      getItemParts: this.getItemParts,
      getVersionCid: this.getVersionCid,
    } = options);
    ({
      prepareForStore: this.prepareForStore,
      sanitizeItem: this.sanitizeItem,
      postSanitizeItem: this.postSanitizeItem,
      postProcess: this.postProcess,
      invertPostProcess: this.invertPostProcess,
      pickRevertableFields: this.pickRevertableFields,
    } = options);

    assert(
      _.all([
        this.sanitizeItem,
        this.prepareForStore,
        this.postProcess,
        this.invertPostProcess,
        this.pickRevertableFields,
        item,
        this.idKey,
        this.itemKey,
        this.itemNameKey,
        this.itemURLKey,
        this.getVersionCid,
      ]),
      'VersionedItemSubstore constructor is missing required options'
    );

    // Assert all item synchronous events are present
    const {load, close, revert, update, registerObjects} = item;
    assert(
      _.all([load, close, revert, update, registerObjects]),
      'VersionedItemSubstore is missing required item events'
    );

    // Assert all asynchronous events are present
    const asyncEvents = [item.save];
    if (version != null) {
      asyncEvents.push(version.load);
    }
    if (versions != null) {
      asyncEvents.push(versions.fetch);
    }
    if (this.asyncItemLoad) {
      asyncEvents.push(load);
    }
    for (const e of Array.from(asyncEvents)) {
      assert(e, 'VersionedItemSubstore is missing required async events');
      const {init, completed, failed} = e;
      assert(_.all([init, completed, failed]), 'VersionedItemSubstore is missing required async events');
    }
  }

  // Substore methods

  resetState(): void {
    for (const id in this.items) {
      if (this._isAutoSaveEnabled(id)) {
        this.items[id].autoSaver?.stop();
      }
    }
    this.items = {};
    this.versions = {};
  }

  getEditorState(id: Id): ItemEditorState<TClientRoot, TClientRootPart, TItemKey, TIdKey> {
    return this.postProcess(
      _.extend(
        {
          isLatest: this._isLatest(id),
          lockedFromExternalChange: this.isLockedFromExternalChange(id),
          openVersionId: this._openVersionId(id),
          openVersionApiId: this._openVersionApiId(id),
          openVersionModifiedAt: this._openVersionModifiedAt(id),
          isAutoSaving: this._isAutoSaveEnabled(id) && this.items[id].autoSaver?.isTicking(),
          cidIdMap: this.items[id].cidIdMap,
          metadata: {
            latestVersionId: this.items[id].latestVersionId,
            clientId: VersioningConstants.clientId,
            action: this.getAction(id),
          },
        },
        this.items[id]
      )
    );
  }

  getVersionState(id: Id): ItemVersionState<TServerVersion> {
    return _.extend(
      {
        openVersionId: this._openVersionId(id),
        openVersionApiId: this._openVersionApiId(id),
        openVersionModifiedAt: this._openVersionModifiedAt(id),
        isLatest: this._isLatest(id),
        unsaved: this.hasUnsavedChanges(id),
        dirty: this.items[id].dirty,
        savedVersion: this.items[id].savedVersion,
      },
      this.versions[id]
    );
  }

  hasUnsavedChanges(id: Id): boolean {
    return this.items[id].savedVersion !== this.items[id].openVersion;
  }

  isLockedFromExternalChange(id: Id): boolean {
    return this.items[id].lockedFromExternalChange;
  }

  // Returns true if an item with the specified id is in the store.
  // Useful for returning early if an asynchronous event happens after the item is removed.
  inStore(id: Id): boolean {
    return this.items[id] != null;
  }

  isUnsaved(id: Id): boolean {
    return this.inStore(id) && this.items[id].openVersion !== this.items[id].savedVersion;
  }

  getItemUnsafe(id: Id): TClientRoot {
    const itemState = this.getItemStateUnsafe(id);
    return itemState[this.itemKey];
  }

  getItem(id: Id): TClientRoot | null {
    const itemState = this.getItemState(id);
    return itemState ? itemState[this.itemKey] : null;
  }

  getItemStateUnsafe(id: Id): ItemEditorState<TClientRoot, TClientRootPart, TItemKey, TIdKey> {
    const itemState = this.getItemState(id);
    // TODO: convert to assert BNCH-135471
    debugAssert(() => itemState != null, `Item ${id} not found`);
    return itemState!;
  }

  getItemState(id: Id): ItemEditorState<TClientRoot, TClientRootPart, TItemKey, TIdKey> | undefined {
    return this.items[id];
  }

  getItemStateParts(id: Id): Array<{itemPartId: string; itemPart: TClientRootPart}> | undefined {
    const itemState = this.getItemState(id);
    return itemState ? this.getItemParts(itemState[this.itemKey]) : undefined;
  }

  getIdFromCid(id: Id, cid: string): Id | undefined {
    return this.getItemState(id)?.cidIdMap[cid];
  }

  private setAction(id: Id, action: string): void {
    this._updateItemState(id, {
      actionMeta: {
        action,
        versionId: this.items[id].openVersion,
      },
    });
  }

  private getAction(id: Id): string | null {
    const {actionMeta, savedVersion} = this.items[id];
    if (!actionMeta) {
      return null;
    }
    if (
      actionMeta.versionId < savedVersion ||
      (actionMeta.action === VersioningConstants.ACTION_RESET_VERSION &&
        actionMeta.versionId === savedVersion)
    ) {
      return null;
    }
    return actionMeta.action;
  }

  disableAutoSaver(id: Id): void {
    const itemState = this.getItemState(id);
    if (itemState) {
      itemState.autoSaver?.stop();
      itemState.autoSaver = null;
    }
  }

  // The custom save handler is currently be used in the Document world,
  // as Documents in Step Configuration want to handle the save via their
  // own save rather than using the Document PATCH route
  getCustomSaveHandler(id: Id): ItemSaveHandler | undefined {
    return this.getItemState(id)?.customSaveHandler;
  }

  setCustomSaveHandler(id: Id, customSaveHandler: ItemSaveHandler): void {
    const itemState = this.getItemState(id);
    if (itemState) {
      itemState.customSaveHandler = customSaveHandler;
    }
  }

  setRelatedDocumentIdGetter(id: Id, getRelatedDocumentIds: () => Array<string>): void {
    const itemState = this.getItemState(id);
    if (itemState) {
      itemState.getRelatedDocumentIds = getRelatedDocumentIds;
    }
  }

  getRelatedDocumentIds(id: Id): Array<string> {
    const itemState = this.getItemState(id);
    if (itemState && itemState.getRelatedDocumentIds) {
      return itemState.getRelatedDocumentIds();
    }
    return [];
  }

  /**
   * Generic update method that replaces the store item with `item`.
   */
  updateItem(id: Id, item: TClientRoot, options?: UpdateOptions): void {
    const {
      bumpVersion,
      performTableEvaluation,
      skipValidationStalenessCheck = false,
      updatedItemPartIndexes,
      canIncrementalSave,
      multidocTableOp,
      evalMetrics,
    } = options ?? {};
    assert(!bumpVersion || !this.items[id].dirty, 'Cannot update an item that is out of date');
    if (bumpVersion && !context.get('skipBumpVersionForNonEdit')) {
      this._updateItemState(id, {
        openVersion: this.items[id].openVersion + 1,
      });
    }
    const prevItem = this.items[id][this.itemKey];
    const sanitizedItem = this.sanitizeItem(item, this.items[id][this.itemKey]);
    let postSanitizedItem = this.postSanitizeItem
      ? this.postSanitizeItem(id, sanitizedItem, prevItem, {
          bumpVersion,
          skipValidationStalenessCheck,
          performTableEvaluation,
          multidocTableOp,
          evalMetrics,
        })
      : sanitizedItem;

    // @ts-expect-error ts(2322)
    this.items[id][this.itemKey] = postSanitizedItem;

    if (this.items[id].autoSaver && postSanitizedItem && bumpVersion) {
      this.items[id].autoSaver.itemPartSaveTracker?.addUnsavedItemPart(
        postSanitizedItem,
        BenchlingConfig.ELN_USE_NOTE_PART_LEVEL_SAVING && canIncrementalSave && updatedItemPartIndexes
          ? updatedItemPartIndexes
          : [UPDATE_ALL_ITEM_PARTS]
      );
    }

    // Even if specifying bumpVersion as true causes the AutoSaver to attempt an auto-save on the next tick,
    // we also manually queue a save in case the AutoSaver unexpectedly stopped.
    if (bumpVersion && this._isAutoSaveEnabled(id)) {
      const action = context.get('immediateAutoSaverQueueSaveAction');
      // @ts-expect-error ts(2554)
      const filename = this.items[id].autoSaver?.friendlyFileName({withMarkdown: true});
      // (throttled)QueueSave may call an action in the same callstack, so we defer to avoid re-entrance.
      _.defer(() => {
        // Don't try to save if the item has been removed from the store.
        const item = this.items[id];
        if (item) {
          if (!item.autoSaver) {
            notifications.warn('Auto-save is unavailable. Please save manually.');
            return;
          }
          if (action) {
            this.setAction(id, action);
            item.autoSaver.queueSave(true);
          } else {
            item.autoSaver.throttledQueueSave();
          }
        } else {
          notifications.warn(`${filename} was closed before the last edit was able to be saved.`);
        }
      });
    }
  }

  _isItemPartLevelSavingEnabled(id: Id): boolean {
    return Boolean(
      BenchlingConfig.ELN_USE_NOTE_PART_LEVEL_SAVING &&
      this._isAutoSaveEnabled(id) &&
      this.enableItemPartLevelSaving
    );
  }

  getUnsavedItemParts(id: Id): Array<TClientRootPart> | typeof UPDATE_ALL_ITEM_PARTS | undefined {
    return this._isItemPartLevelSavingEnabled(id)
      ? this.items[id].autoSaver?.itemPartSaveTracker?.getUnsavedItemParts()
      : undefined;
  }

  resetSaveTracker(id: Id): void {
    if (this._isItemPartLevelSavingEnabled(id)) {
      const cidIdMap = this.items[id].cidIdMap;
      this.items[id].autoSaver?.itemPartSaveTracker?.reset(id, cidIdMap);
    }
  }

  markAllForUpdate(id: Id): void {
    if (this._isItemPartLevelSavingEnabled(id)) {
      this.items[id].autoSaver?.itemPartSaveTracker?.markAllForUpdate();
    }
  }

  queueSave(id: Id, isMandatory?: boolean): void | JQueryPromise<boolean> | undefined {
    const item = this.items[id];
    if (item) {
      const action = context.get('immediateAutoSaverQueueSaveAction');
      if (action) {
        this.setAction(id, action);
      }
      return item.autoSaver?.queueSave(isMandatory);
    } else {
      notifications.warn(`Item ${id} is no longer open.`);
      return undefined;
    }
  }

  // Generic update method that applies `op` to the store item, use bumpVersion to trigger auto-save
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  applyOpToItem(id: Id, op: Spec<any, never>, options?: UpdateOptions): void {
    this.updateItem(id, reactUpdate(this.items[id][this.itemKey], op), options);
  }

  // Generic update method that merges data into the store item, use bumpVersion to trigger auto-save
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  mergeItem(id: Id, data: any, options?: UpdateOptions): void {
    this.applyOpToItem(id, {$merge: data}, options);
  }

  // Returns true if it handled the action.
  handlePayload(action: ItemAction<TServerRoot, unknown, TItemKey, TIdKey>): boolean {
    let id: Id;
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    let item: any;

    if (this.asyncItemLoad) {
      switch (action.actionType) {
        case this.events.item.load.init:
          id = action[this.idKey];
          // If we are loading again, we don't need to clear out existing state.
          if (this.items[id] == null) {
            this._registerId(id, {
              disableAutoSaver: action.disableAutoSaver,
              customAutoSaver: action.customAutoSaver,
              customSaveHandler: action.customSaveHandler,
            });
          }
          this._updateItemState(id, {
            opening: true,
          });
          return true;
        case this.events.item.load.completed:
          id = action[this.idKey];
          if (!this.inStore(id)) {
            return false;
          }
          item = action[this.itemKey];
          this._loadItem(id, item, {
            bumpVersion: action.bumpVersion,
            performTableEvaluation: action.performTableEvaluation,
          });
          this._updateItemState(id, {
            dirty: false,
            opening: false,
          });
          return true;
        case this.events.item.load.failed:
          id = action[this.idKey];
          if (!this.inStore(id)) {
            return false;
          }
          this._updateItemState(id, {
            opening: false,
            ...(action.clearDirtyState && {dirty: false}),
          });
          return true;
      }
    } else if (action.actionType === this.events.item.load) {
      id = action[this.idKey];
      item = action[this.itemKey];
      // If we are loading again, we don't need to clear out existing state.
      if (this.items[id] == null) {
        this._registerId(id, {
          disableAutoSaver: action.disableAutoSaver,
          customAutoSaver: action.autoSaver,
          customSaveHandler: action.customSaveHandler,
        });
      }
      this._loadItem(id, item);
      return true;
    }

    switch (action.actionType) {
      case this.events.item.dirty:
        id = action[this.idKey];
        this._updateItemState(id, {
          dirty: true,
        });
        return true;

      case this.events.item.close:
        id = action[this.idKey];
        this._deregisterId(id);
        return true;

      case this.events.item.update: {
        id = action[this.idKey];
        if (!this.inStore(id)) {
          return false;
        }

        const bumpVersion = action.bumpVersion != null ? action.bumpVersion : true;
        let {op, cidIdMap} = action;
        const isEditAllowed = this._isLatest(id) || !action.bumpVersion;
        if (!isEditAllowed) {
          notifications.error('Cannot edit older version. Please refresh to get the latest version.');
          return false;
        }
        this.applyOpToItem(id, op, {
          bumpVersion,
          performTableEvaluation: action.performTableEvaluation,
          updatedItemPartIndexes: action.updatedItemPartIndexes,
          canIncrementalSave: action.canIncrementalSave,
          multidocTableOp: action.multidocTableOp,
          evalMetrics: action.evalMetrics,
        });

        // Allow update actions that bring a subgraph to register that subgraph's cids in the cidIdMap
        this._updateItemState(id, {
          cidIdMap: _.extend({}, this.items[id].cidIdMap, cidIdMap),
        });
        return true;
      }

      case this.events.item.revert:
        id = action[this.idKey];
        assert(this.inStore(id), 'VersionedItemSubstore revert action received for id not in store');

        if (action.op != null) {
          const itemInStore = this.items[id][this.itemKey];
          item = reactUpdate(itemInStore, action.op);
        } else {
          item = action[this.itemKey];
        }
        this._undoRedoItem(id, item, action.multidocTableOp);
        return true;

      case this.events.item.resetToOpenVersion: {
        id = action[this.idKey];
        assert(this.inStore(id), 'VersionedItemSubstore reset action received for id not in store');
        this.mergeItem(id, {}, {bumpVersion: true});
        this._clearHistory(id);
        return true;
      }

      case this.events.item.save.init: {
        id = action[this.idKey];
        this._updateItemState(id, {saving: true});
        if (this._isItemPartLevelSavingEnabled(id)) {
          const cidIdMap = this.getItemState(id)?.cidIdMap;
          this.items[id].autoSaver?.itemPartSaveTracker?.reset(id, cidIdMap);
        }
        return true;
      }

      case this.events.item.save.completed: {
        const {cidIdMap, savedVersion, versionId, serverData} = action;
        id = action[this.idKey];
        if (!this.inStore(id)) {
          // We currently rely on the autoSaver to handle managing unsaved drafts in localStorage; however,
          // if a file is removed from the store before the save completes, the unsaved draft will never be
          // cleaned up and will unnecessarily prompt the user to recover the draft in the future.
          const draftId = drafts.draftId(this.itemKey, id);
          drafts.removeDraft(draftId);
          return false;
        }

        // In case of re-ordering of packets, latestVersionId should never go down.
        let {latestVersionId} = this.items[id];
        // @ts-expect-error ts(18048)
        if (versionId != null && versionId > latestVersionId) {
          latestVersionId = versionId;
        }

        const newCidMap = _.extend({}, this.items[id].cidIdMap, cidIdMap);

        this._updateItemState(id, {
          saving: false,
          saveSuccess: true,
          savedVersion,
          latestVersionId,
          // Update cid maps for the item and each subitem
          cidIdMap: newCidMap,
        });

        // Merge in data from server
        item = this.items[id][this.itemKey];
        // item can be null if QuickEditModal is closed and re-open starts before save comes back
        // TODO(T1847): remove after adding refcounts
        if (item == null) {
          break;
        }

        // If server response includes a change (e.g. editURL), merge the changes
        if (
          serverData != null &&
          _.pairs(serverData).some((...args) => {
            const [key, value] = Array.from(args[0]);
            return !isEqual(item[key], value);
          })
        ) {
          this.mergeItem(id, serverData);
        }

        if (this._isAutoSaveEnabled(id)) {
          if (this._isItemPartLevelSavingEnabled(id)) {
            this.items[id].autoSaver?.itemPartSaveTracker?.validate(id, newCidMap);
          }
          // Because the AutoSaver operates on a tick, it's possible that there are two requests that go out
          // in parallel for saving an entry. If the first request fails (i.e. due to a db timeout), the
          // AutoSaver is paused. If the second request then succeeds, it will notify the user of success,
          // but will /not/ restart the AutoSaver. If the user continues to make edits, they will never save.
          // We avoid this by ensuring that the AutoSaver is running after a successful save.
          this.items[id].autoSaver?.resumeIfStopped();

          // Force a tick now so that we don't give false warnings about unsaved changes
          this.items[id].autoSaver?.tick(false);
        }
        return true;
      }

      case this.events.item.save.failed: {
        id = action[this.idKey];
        if (!this.inStore(id)) {
          return false;
        }

        this._updateItemState(id, {
          saving: false,
          saveSuccess: false,
        });

        const status = action.error != null ? action.error.status : undefined;
        if (status != null) {
          const downtime503 = status === 503 && action.error?.responseJSON?.downtime;

          if (status === 409) {
            // For 409, the client has a conflict: lock the item in addition to stopping the auto saver.
            this._updateItemState(id, {
              lockedFromExternalChange: true,
              latestVersionId: action.error.responseJSON.latestVersionId,
            });
          } else if (downtime503) {
            // For downtime 503, lock the item
            this._updateItemState(id, {dirty: true});
          }

          if (this._isAutoSaveEnabled(id)) {
            if (downtime503) {
              // For downtime 503, pause the autosaver
              this.items[id].autoSaver?.pause({id, status, downtime: true, error: action.error.responseJSON});
            } else if (status === 503 || (status === 500 && action.error?.responseJSON?.retry)) {
              // Retry for 503s (no webservers in LB) and some 500s (resulting from postgres OperationalErrors)
              this.items[id].autoSaver?.notifyRetry(status);
            } else if (400 <= status && status <= 500) {
              // The remaining 400-500 status codes indicate bad client input or resulting bad server handling,
              // which we expect to remain the same on replaying the request, so we stop saving and let the user
              // know.
              this.items[id].autoSaver?.pause(
                {id, status, error: action.error.responseJSON},
                {lockedFromExternalChange: this.items[id].lockedFromExternalChange}
              );
            }
          }
        }
        return true;
      }

      case this.events.item.registerObjects:
        id = action[this.idKey];
        if (!this.inStore(id)) {
          return false;
        }
        Object.assign(this.items[id].cidIdMap, action.cidIdMap);
        return false;
    }

    if (this.events.versions != null) {
      switch (action.actionType) {
        case this.events.versions.fetch.init:
          id = action[this.idKey];
          if (!this.inStore(id)) {
            return false;
          }
          this._updateVersionState(id, {fetching: true});
          return true;
          break;

        case this.events.versions.fetch.completed: {
          const {versions, parent} = action;
          // Omitted parent key means there is no parent
          // A parent key with value null indicates a deleted parent.
          const hasParent = 'parent' in action;
          id = action[this.idKey];
          if (!this.inStore(id)) {
            return false;
          }
          this._updateVersionState(id, {
            fetching: false,
            fetchSuccess: true,
            versions,
            hasParent,
            parent: parent != null ? parent : null,
          });
          return true;
          break;
        }

        case this.events.versions.fetch.failed:
          id = action[this.idKey];
          if (!this.inStore(id)) {
            return false;
          }
          this._updateVersionState(id, {
            fetching: false,
            fetchSuccess: false,
          });
          return true;
          break;
      }
    }

    if (this.events.version != null) {
      switch (action.actionType) {
        case this.events.version.load.init: {
          const {versionId} = action;
          id = action[this.idKey];
          if (!this.inStore(id)) {
            this._registerId(id, {
              disableAutoSaver: action.disableAutoSaver,
              customAutoSaver: action.autoSaver,
              customSaveHandler: action.customSaveHandler,
            });
          }
          this._updateVersion(id, versionId, {
            $merge: {fetching: true},
          });
          return true;
        }

        case this.events.version.load.completed: {
          const {versionId, version} = action;
          id = action[this.idKey];
          if (!this.inStore(id)) {
            return false;
          }

          this._loadItem(id, version);
          this._updateVersion(id, versionId, {
            $merge: {fetching: false},
          });

          // If we were showing a warning about being locked out and the user is now viewing the latest
          // version, close the warning.
          if (this._isLatest(id)) {
            notifications.close(this._lockWarningId(id));
          }
          return true;
        }

        case this.events.version.load.failed: {
          const {versionId} = action;
          id = action[this.idKey];
          if (!this.inStore(id)) {
            return false;
          }
          this._updateVersion(id, versionId, {
            $merge: {fetching: false},
          });
          return true;
        }
      }
    }

    if (this.events.collab != null) {
      switch (action.actionType) {
        case this.events.collab.collabJoin:
          assert(action.userId != null, 'User id was expected but did not exist');
          id = action[this.idKey];
          if (!this.inStore(id)) {
            return false;
          }
          this._updateItemState(id, {
            collaboratorIds: _.union(this.items[id].collaboratorIds, [action.userId]),
          });
          return true;
        case this.events.collab.collabLeave:
          assert(action.userId != null, 'User id was expected but did not exist');
          id = action[this.idKey];
          if (!this.inStore(id)) {
            return false;
          }
          this._updateItemState(id, {
            collaboratorIds: _.without(this.items[id].collaboratorIds, action.userId),
          });
          return true;
      }
    }

    if (this.events.item.rename != null && this.events.item.rename === action.actionType) {
      let name;
      ({id, name} = action);
      if (!this.inStore(id)) {
        return false;
      }
      this.mergeItem(id, _.object([this.itemNameKey], [name]));
      return true;
    }
    if (this.events.item.move != null && this.events.item.move === action.actionType) {
      const {ids, folder} = action;
      let hasChanged = false;
      ids.forEach((id: string) => {
        if (this.inStore(id)) {
          this.mergeItem(id, {folder});
          hasChanged = true;
        }
      });
      return hasChanged;
    } else if (this.events.item.bulkUpdate != null && this.events.item.bulkUpdate === action.actionType) {
      for (const item of Array.from(action.items)) {
        if (this.inStore(item[this.idKey])) {
          this._loadItem(item[this.idKey], item[this.itemKey]);
        }
      }
      return true;
    }

    return false;
  }

  private _lockWarningId(id: Id): string {
    return `lock-warning:${id}`;
  }

  private _openVersionId(id: Id): Id | false {
    const item = this.items[id][this.itemKey];
    return item != null && this.items[id].cidIdMap[this.getVersionCid(item)];
  }

  private _getOpenVersion(id: Id): TServerVersion | undefined {
    const versionId = this._openVersionId(id);
    return versionId != null
      ? this.versions?.[id]?.versions?.find((version) => version.id === versionId)
      : undefined;
  }

  private _openVersionApiId(id: Id): string | undefined {
    const version = this._getOpenVersion(id);
    // Some versions returned from the server use camel case and some use snake case
    return version?.apiIdentifier ?? version?.api_identifier;
  }

  private _openVersionModifiedAt(id: Id): string | undefined {
    const version = this._getOpenVersion(id);
    return version?.modifiedAt;
  }

  // Clears the undo/redo buffer
  _clearHistory(id: Id): void {
    this.items[id].historyManager.reset();
    // Entries do not use the above historyManager, since each tab maintains its own buffers.
    // So instead, we signal to the component that the history has changed, allowing it to opt-in for
    // clearing the history.
    this.items[id].historyResetCount += 1;
  }

  // Returns true if the latest version of an item is loaded into items[id].item
  _isLatest(id: Id): boolean {
    debugAssert(
      () => Boolean(this.items[id]),
      '_isLatest could not find item in store - this message includes the id for debugging purposes.',
      {id}
    );
    const {latestVersionId, cidIdMap} = this.items[id];
    const item = this.items[id][this.itemKey];
    return item == null || cidIdMap[this.getVersionCid(item)] === latestVersionId;
  }

  // Loads a given object into the item's state hash.
  _loadItem(
    id: Id,
    item: TServerRoot,
    {bumpVersion = false, performTableEvaluation = true}: UpdateOptions = {}
  ): void {
    const cidIdMap = {};
    item = ensureMutable(item);
    const preparedItem = this.prepareForStore(item, cidIdMap);

    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const updates: {cidIdMap: Record<string, string>; latestVersionId?: number; [key: string]: any} = {
      cidIdMap,
      // @ts-expect-error ts(2339)
      latestVersionId: item.latestVersionId,
    };
    const sanitizedItem = this.sanitizeItem(preparedItem);
    const postSanitizedItem = this.postSanitizeItem
      ? this.postSanitizeItem(id, sanitizedItem, null, {bumpVersion, performTableEvaluation})
      : sanitizedItem;
    updates[this.itemKey] = postSanitizedItem;
    this._updateItemState(id, updates);
    // If we just replaced the object entirely with upstream data, then we should throw away local history,
    // as it would be odd to try and revert before the latest update from the server.
    this._clearHistory(id);
  }

  private _isAutoSaveEnabled(id: Id): boolean {
    return this.inStore(id) && this.items[id].autoSaver != null;
  }

  // Adds an item state hash to the store.
  _registerId(
    id: Id,
    {
      disableAutoSaver,
      customAutoSaver,
      customSaveHandler,
    }: {
      disableAutoSaver?: boolean;
      customAutoSaver?: AutoSaver<TClientRoot, TClientRootPart> | null;
      customSaveHandler?: ItemSaveHandler;
    } = {}
  ): void {
    // items is a mapping from id to the following hash:
    //   item:
    //     the item itself
    //   historyManager:
    //     Stores a buffer of local history. Exposed in state for editor to be pushed to.
    //   cidIdMap:
    //     A mapping from cid to id for any subcomponents.
    //   latestVersionId:
    //     The latest versionId of the item. This is used to determine if we are viewing the latest version.
    //   openVersion/savedVersion:
    //     Counters used to determine if auto save needs to be triggered. Used by AutoSaver
    //   historyResetCount:
    //     Counter used to signal components that any component history should be discarded due to fetching
    //     upstream changes that should not be revertible.
    //   collaboratorIds:
    //     List of collaborators, sorted in increasing order of the last time when the user started working
    //     on the item.
    //   saving/saveSuccess:
    //     booleans indicating save status
    //   actionMeta:
    //     an optionally set {action, versionId} object indicating an action that caused the save, to be
    //     threaded into the API call for performing the save

    debugAssert(
      () => this.items[id] == null,
      'VersionedItemSubstore attempted to register an id that already exists in the store'
    );
    // @ts-expect-error ts(2322)
    this.items[id] = {
      historyManager: new HistoryManager(),
      cidIdMap: {},
      latestVersionId: -1,
      openVersion: 0,
      savedVersion: 0,
      historyResetCount: 0,
      collaboratorIds: [],
      saving: false,
      saveSuccess: true,
      lockedFromExternalChange: false,
      actionMeta: null,
      customSaveHandler,
    };
    // @ts-expect-error ts(2322)
    this.items[id][this.itemKey] = null;
    if (this.doSave != null && !disableAutoSaver) {
      if (customAutoSaver) {
        this.items[id].autoSaver = customAutoSaver;
      } else {
        this.items[id].autoSaver = new AutoSaver({
          // @ts-expect-error ts(2322)
          id,
          itemKey: this.itemKey,
          doSave: this.doSave.bind(null, id),
          getItemState: this.getItemState.bind(this, id),
          getItemParts: this.getItemStateParts.bind(this, id),
        });
      }
    }
    // versions is a mapping from id to the following hash:
    //   versions:
    //     An array of note version summary dicts.
    //   fetching/fetchSuccess:
    //     booleans indicating fetch status
    this.versions[id] = {
      versions: [],
      fetching: false,
      fetchSuccess: false,
      hasParent: false,
      parent: null,
    };
  }

  // Removes an item from the store.
  _deregisterId(id: Id): void {
    if (this._isAutoSaveEnabled(id)) {
      this.items[id].autoSaver?.stop();
    }
    // @ts-expect-error ts(2345)
    SpreadsheetEvalCache.evictValues(id);
    delete this.items[id];
    delete this.versions[id];
  }

  // Merges in revertable fields from item into the item with the specified id.
  private _undoRedoItem(id: Id, item: TClientRoot, multidocTableOp?: MultidocTableOpMap): void {
    // itemFragment will only consist of the keys that can be undone/redone.
    const output = this.invertPostProcess(item);
    const itemFragment = this.pickRevertableFields(output);
    this.mergeItem(id, itemFragment, {
      bumpVersion: true,
      skipValidationStalenessCheck: true,
      multidocTableOp,
    });
  }

  // Merge in changes to the specified item state
  _updateItemState(id: Id, state: Partial<BaseItemEditorState>): void {
    _.extend(this.items[id], state);
  }

  // Merge in changes to the specified version (e.g. fetching)
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  private _updateVersion(id: Id, versionId: Id, update: Spec<any, never>): void {
    this.versions[id].versions = Array.from(this.versions[id].versions).map((version) =>
      version.id === versionId ? reactUpdate(version, update) : version
    );
  }

  // Merge in changes to the specified item's version state
  private _updateVersionState(id: Id, state: Partial<ItemVersionState<TServerVersion>>): void {
    _.extend(this.versions[id], state);
  }

  __serverBootstrapItem({id, item}: {id: Id; item: TServerRoot}): void {
    this._registerId(id);
    this._loadItem(id, item);
  }
}

export default VersionedItemSubstore;
